'use client'

import {cn} from '../../../lib/utils'

export const CLIENT_RWD_SEARCH_INPUT_CLASS = '!h-11 !min-h-11 !py-2'
export const CLIENT_RWD_HEADER_ROW_CLASS = 'flex min-h-[44px] items-center justify-between gap-3'
export const CLIENT_RWD_PAGE_SECTION_CLASS = 'desktop:hidden flex flex-col gap-4 pt-0'
export const CLIENT_RWD_PAGE_SECTION_CONTENT_CLASS = 'flex flex-col gap-4'

export const CLIENT_RWD_CARD_CTA_CLASS =
    'w-full !h-12 !min-h-[48px] !rounded-xl !px-6 !py-0 !text-body !font-medium !leading-none'

export const CLIENT_RWD_CARD_TIME_COLUMN_CLASS = 'flex min-w-[54px] shrink-0 flex-col items-center pt-[2px]'

export const CLIENT_RWD_CARD_HEADER_TITLE_CLASS =
    'btn-micro block min-h-0 w-full border-0 bg-transparent p-0 text-left text-[16px] font-semibold leading-[20.8px] tracking-[-0.02em] text-gray-900 transition-colors hover:text-primary-600 dark:text-gray-100 dark:hover:text-primary-400'

export const CLIENT_RWD_CARD_HEADER_TITLE_TEXT_CLASS =
    'block min-w-0 w-full max-w-full overflow-x-auto whitespace-nowrap scrollbar-hide'

export const CLIENT_RWD_CARD_LOCATION_ROW_CLASS =
    'mt-0 flex min-w-0 items-center gap-1.5 overflow-x-auto whitespace-nowrap scrollbar-hide text-[13px] font-medium leading-[18px] text-gray-600 dark:text-gray-300'

export const CLIENT_RWD_CARD_LOCATION_ICON_CLASS = 'h-[14px] w-[14px] shrink-0 text-gray-400 dark:text-gray-500'

export const CLIENT_RWD_PRESS_CLASS =
    'active:scale-[0.97] transition-[color,background-color,border-color,box-shadow,scale] duration-press ease-out motion-reduce:active:scale-100 disabled:active:scale-100'

export const CLIENT_RWD_INFO_BUTTON_CLASS = cn(
    'btn-micro relative z-10 inline-flex h-11 w-11 min-h-[44px] shrink-0 items-center justify-center rounded-xl border !p-0',
    'border-[rgba(15,23,42,0.04)] bg-[#F3F4F6] text-gray-500 shadow-[0_1px_2px_rgba(15,23,42,0.04)]',
    CLIENT_RWD_PRESS_CLASS,
    'hover:bg-[#EDEFF3] hover:text-primary-600 dark:border-white/10 dark:bg-gray-800/90 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-primary-400'
)

export const getClientSectionTabClass = (isActive: boolean) => cn(
    'btn-micro inline-flex !h-11 !min-h-11 shrink-0 items-center justify-center rounded-[12px] px-4 py-0 text-sm font-semibold leading-none',
    CLIENT_RWD_PRESS_CLASS,
    isActive
        ? 'bg-white text-gray-900 shadow-sm dark:bg-gray-700 dark:text-gray-100'
        : 'text-gray-600 hover:bg-gray-50 hover:text-gray-800 dark:text-gray-300 dark:hover:bg-gray-750 dark:hover:text-gray-100'
)
